<template>
  <div ref="target">
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { useIntersectionObserver } from '@vueuse/core';

  interface IProps {
    handleIntersect: () => void | Promise<void>;
    handleLeave?: () => void | Promise<void>;
    rootMargin?: string;
    enabled?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    rootMargin: '0px 0px 50px 0px',
    enabled: true,
    handleLeave: () => {},
  });

  const target = ref<HTMLElement>();

  if (props.enabled) {
    useIntersectionObserver(
      target,
      ([entry]: IntersectionObserverEntry[]) => {
        if (entry?.isIntersecting) {
          props.handleIntersect();
        } else {
          props.handleLeave?.();
        }
      },
      { rootMargin: props.rootMargin }
    );
  }
</script>
